import { Component, input } from '@angular/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ElementDirective } from '@shared/directives';
import { SelectionButtonThirdVariantConfig } from '@shared/models';
import {
  AmountPartsPipe,
  RewardPipe,
  SafePipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { SelectionButtonBaseClass } from '../selection-button.base.class';

@Component({
  hostDirectives: [
    {
      directive: ElementDirective,
      inputs: ['modalType: "select"'],
    },
  ],
  selector: 'b2c-variant3',
  styleUrl: './variant3.component.scss',
  templateUrl: './variant3.component.html',
  imports: [
    SafePipe,
    RewardPipe,
    AmountPartsPipe,
    ButtonComponent,
    VariableReplacementPipe,
  ],
})
export class Variant3Component extends SelectionButtonBaseClass {
  config = input.required<SelectionButtonThirdVariantConfig>();
}
